import React, { useState, useEffect } from 'react';
import { Button, Box, Typography, Grid, TextField, IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { ListBox } from '@progress/kendo-react-listbox';
import { guid } from '@progress/kendo-react-common';
import { TileLayout } from "@progress/kendo-react-layout";
import Movements from '../../pages/Movements/Movements';
import PartialTrip from '../../pages/PartialTrip/PartialTrip';
import Agenda from '../Agenda/Agenda';
import TripRoutes from '../../pages/TripRoutes/TripRoutes';
import ShipmentMovements from '../../pages/ShipmentMovements/ShipmentMovements';
import MapView from '../../pages/MapView/MapView';
import VehicleResource from '../../pages/VehicleResource/VehicleResource';
import _ from 'lodash';
import { updateCustomViews, updateViewSelection } from '../../../../shared/ReduxStore/Reducers/updateSideNavReducer';
import { useDispatch, useSelector } from 'react-redux';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import commonApiService from '../../../../shared/common-utilities/services/commonApiService';
import Spinner from "../../common/Spinner/Spinner";
import { postSavedView } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import { fetchSavedView } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import AlertComponent from '../../../../shared/common-utilities/common/AlertComponent';
import { useLocation, useNavigate } from 'react-router-dom';
import commonPageService from '../../../../shared/common-utilities/services/commonPageService';
import getSetDataService from '../../../../shared/common-utilities/services/getSetDataService';
import i18_en from '../../../../jsonStore/i18_en.json';
import WindowComponent from '../Window/WindowComponent';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService';
import AgendaView from '../../pages/ResourceView/AgendaView';

let apiService = commonApiService();
let commonService = commonPageService();
let service = getSetDataService();
let storageService = dataStorageService();

const _guid = guid();
const CreateCustomView = () => {


  // const dataMainGrids = [{ index: 1, title: 'Movements', selected: false }, { index: 2, title: 'Partial Trip', selected: false }, { index: 3, title: 'Agenda', selected: false }];
  // const dataSubGrid = [{ index: 1, title: 'Partial Trip', parent: ['Movements'], selected: false }, { index: 2, title: 'Routes', parent: ['Movements', 'Partial Trip', 'Agenda'], selected: false }, { index: 3, title: 'Shipment Movements', parent: ['Movements', 'Partial Trip', 'Agenda'], selected: false }, { index: 5, title: 'Map', parent: ['Movements', 'Partial Trip', 'Agenda'], selected: false }, { index: 6, title: 'Vehicle Resource', parent: ['Movements', 'Partial Trip'], selected: false }]
  const dataMainGrids = [{ index: 1, title: 'Partial Trip', selected: false },{ index: 2, title: 'Agenda View', selected: false }];
  const dataSubGrid = [{ index: 1, title: 'Partial Trip', parent: ['Movements','Agenda View'], selected: false }, { index: 2, title: 'Routes', parent: ['Movements', 'Partial Trip','Agenda View'], selected: false }, { index: 3, title: 'Shipment Movements', parent: ['Movements', 'Partial Trip', 'Agenda View'], selected: false }]

  const [gridState, setGridState] = useState({
    mainGrid: dataMainGrids,
    childGrid: dataSubGrid,
    draggedItem: {}
  })
  const [views, setViews] = useState();
  const [viewsAllData, setViewsAllData] = useState();
  const [parentGrid, setParentGrid] = useState("");
  const [selectedTiles, setSelectedTiles] = useState([]);
  const [subGrid, setSubGrid] = useState([]);
  const [showedSubGrid, setShowedSubGrid] = useState([]);
  const [openNamePopup, setOpenNamePopup] = useState(false);
  const [customViewKey, setCustomViewKey] = useState("");
  const [position, setPosition] = useState();
  const [isSuccessSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
  const [successSnackbarMessage, setSuccessSnackbarMessage] = useState('');
  const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [viewIndex, setViewIndex] = useState(0);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editedTiles, setEditedTiles] = useState([]);
  let updatedViews = views ? views : [];
  const userID = storageService.getLocalStorageData('userID');

  const dispatch = useDispatch();
  const pinItem = useSelector(state => state.pin);
  const location = useLocation();
  const navigate = useNavigate();
  let tempCustomViewKey = '';


  const tiles = [
    {
      title: 'Movements',
      defaultPosition: {
        col: 1,
        colSpan: 4,
        rowSpan: 1,
      },
      hidden: false,
      item: (
        <Movements customView={true} guid={_guid} />
      ),
      field: 'movements',
      isPin: true,
      guid: _guid
    },
    {
      title: 'Partial Trip',
      defaultPosition: {
        col: 1,
        colSpan: 4,
        rowSpan: 1,
      },
      hidden: false,
      item: (
        <PartialTrip customView={true} guid={_guid} />
      ),
      field: 'partialTrips',
      isPin: true,
      guid: _guid
    },
    {
      title: 'Agenda View',
      defaultPosition: {
        col: 1,
        colSpan: 4,
        rowSpan: 1,
      },
      hidden: false,
      item: (
        <AgendaView customView={true} guid={_guid} />
      ),
      isPin: true,
      guid: _guid
    },
    {
      title: 'Routes',
      defaultPosition: {
        col: 1,
        colSpan: 4,
        rowSpan: 1,
      },
      hidden: false,
      item: (
        <TripRoutes customView={true} guid={_guid} />
      ),
      field: 'routes',
      isPin: true,
      guid: _guid
    },
    {
      title: 'Shipment Movements',
      defaultPosition: {
        col: 1,
        colSpan: 4,
        rowSpan: 1,
      },
      hidden: false,
      item: (
        <ShipmentMovements customView={true} guid={_guid} />
      ),
      field: 'ptmovements',
      isPin: true,
      guid: _guid
    },
    {
      title: 'Map',
      defaultPosition: {
        col: 1,
        colSpan: 4,
        rowSpan: 1,
      },
      hidden: false,
      item: (
        <MapView customView={true} guid={_guid} />
      ),
      isPin: true,
      guid: _guid
    },
    {
      title: 'Vehicle Resource',
      defaultPosition: {
        col: 1,
        colSpan: 4,
        rowSpan: 1,
      },
      hidden: false,
      item: (
        <VehicleResource customView={true} guid={_guid} />
      ),
      field: 'vehicles',
      isPin: true,
      guid: _guid
    }
  ];

  useEffect(() => {
    const customViewData = location?.state;
    if (customViewData !== undefined && customViewData !== null) {
      if (customViewData?.data && customViewData?.viewName) {
        const customView = customViewData.data;
        sendApi(customView["userMetadata@odata.mediaReadLink"], customView["@odata.etag"], true);
        setCustomViewKey(customViewData.viewName);
      }

      if (!customViewData?.isEdit) {
        setIsEditMode(false);
        setViews([]);
        setSelectedTiles([]);
        setSubGrid([]);
        setPosition();
        setCustomViewKey("");
        setParentGrid("");
      }
    }
  }, [location?.state])

  useEffect(() => {
    setSelectedTiles(prevTiles => {
      const updatedTiles = prevTiles?.map(item => {
        if (item.field === pinItem.gridFlag) {
          item.isPin = pinItem.isPin;
          item.guid =  pinItem.guid;
          item.customView = true;
        }
        return item;
      });
      return updatedTiles;
    });
  }, [pinItem])

  useEffect(() => {
  }, [subGrid])

  useEffect(() => {
  }, [selectedTiles])

  useEffect(() => {
    fetchUpdateSavedViews('', null);
  }, [])

  useEffect(() => {
    let tempList = []
    tiles?.forEach(item =>
      showedSubGrid?.forEach(element => {
        if (element.title === item.title) {
          tempList.push(item);
        }
      })
    );
    const item = tempList.filter(e => selectedTiles.findIndex(x => x.title === e.title) === -1);
    if (item.length > 0) {
      setSelectedTiles([...selectedTiles, item[0]]);
    }
  }, [showedSubGrid]);

  useEffect(() => {
    if (isEditMode) {
      let tempList = [];
      let grid = [];
      let newItem = {}
      let index = editedTiles.findIndex(item => item.title === 'Agenda View')

      tiles?.forEach(tile => {
        editedTiles?.forEach(element => {
          if(index!=-1) {
            newItem = commonService.mapPages(element.title, "Agenda View" != element.title, element.isPin, element.guid, true)
          } else {
            newItem = commonService.mapPages(element.title, "Partial Trip" != element.title, element.isPin, element.guid, true)
          }
          if (element.title === tile.title) {
            tempList.push({
              ...tile,
              item: (newItem),
              isPin: element.isPin,
              guid : element.guid,
              customView : true,
              defaultPosition: element.defaultPosition
            });
          }
        });
      });

      dataSubGrid.forEach(item =>
        item.parent.includes("Partial Trip") ? grid.push(item) : null
      )
      
      const agendaIndex = tempList.findIndex(item => item?.title === "Agenda View");
      if (index > -1) {
        const [agendaItem] = tempList.splice(agendaIndex, 1);
        tempList.unshift(agendaItem);
      }

      setSubGrid(index!=-1 ? dataSubGrid : grid);
      setSelectedTiles(tempList);
    }
  }, [editedTiles])

  const sendApi = (mediaReadLink, etag, isEdit = false) => {
    setIsLoading(true);
    apiService.get(mediaReadLink, null, null, null, null, etag).then(response => {
      setViews(response);
      if (isEdit) {
        const agendaIndex = response?.[0]?.Tiles.findIndex(item => item.title === "Agenda View");
        let subGrids = []
        if(agendaIndex > -1) {
          subGrids = response?.[0]?.Tiles?.filter(item => item.title !== 'Agenda View');
        } else {
          subGrids = response?.[0]?.Tiles?.filter(item => item.title !== dataMainGrids[0].title);
        }
        setIsEditMode(true);
        setSelectedTiles(response?.[0]?.Tiles);
        setEditedTiles(response?.[0]?.Tiles);
        setPosition(response?.[0]?.place);
        setShowedSubGrid(subGrids);
        setParentGrid(response[0]?.mainGrid);
      }
    })
      .catch(error => {
        console.error('API error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      })
  }

  const fetchUpdateSavedViews = (viewId, savedViewData) => {
    setIsLoading(true);
    const url = `${fetchSavedView}?$filter=(userID eq '${userID}' and title eq 'customView*')`;
    apiService.get(url).then(response => {
      if (response?.value?.length > 0) {
        const parts = response.value[response.value.length - 1].title?.split('/');
        setViewIndex(+parts[1]);
        if (savedViewData === null) {
          setViewsAllData(response.value);
        } else if (response?.value?.length !== 0) {
          const resData = response?.value?.filter(item => item.id === viewId);
          setIsEditMode(false);
          setSelectedTiles([]);
          updateReadLinkData(resData[0], savedViewData);
        }
      } else {
        setViewIndex(0);
      }

    })
      .catch(error => {
        console.error('API error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const postSavedViewsData = (data) => {
    apiService.post(postSavedView, { userID: userID, title: `customView/${viewIndex + 1}/${tempCustomViewKey}` }).then(response => {
      setIsLoading(true);
      updateReadLinkData(response, data);
      setTimeout(() => {
        sendApi(response["userMetadata@odata.mediaReadLink"], response["@odata.etag"]);
      }, 3000);
      dispatch(updateCustomViews(data))
    })
      .catch(error => {
        console.error('API error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const updateReadLinkData = (resData, viewData) => {
    dispatch(updateCustomViews(viewData))
    setIsLoading(true);
    apiService.put(resData["userMetadata@odata.mediaReadLink"], resData['@odata.etag'], viewData).then(response => {
      if (response !== undefined && response !== null) {
        const viewName = service.splitTitle(resData).viewName;
        navigate(`/CustomView`, { state: { data: resData } });
        dispatch(updateViewSelection({ customViewSelectedName: viewName }));
        storageService.setLocalStorageData("ViewName", viewName);
        setSuccessSnackbarOpen(true);
        setSuccessSnackbarMessage(i18_en.viewSavedSuccessfully);
      }
    })
      .catch(error => {
        console.error('API error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const populateChildGrid = (props, data) => {
    setParentGrid(props.dataItem.title);
    setSelectedTiles([]);
    // tiles.filter(item => (item.title == props.dataItem.title && setSelectedTiles([item]) ))
    // tiles.filter(item => 
    //   {
    //     item.title === props.dataItem.title && setSelectedTiles([item]);
    //     return false;
    //   }
    // )

    for (const item of tiles) {
      item.title === props.dataItem.title && setSelectedTiles([item]);
    }
    setGridState({
      ...gridState,
      [data]: gridState[data].map((item) => {
        if (item.title === props.dataItem.title) {
          item['selected'] = true;
        }
        else {
          item['selected'] = false;
        }
        return item;
      })
    });
    let grid = [];
    dataSubGrid.forEach(item =>
      item.parent.includes(props.dataItem.title) ? grid.push(item) : null
    )
    setSubGrid(grid);
    setShowedSubGrid([]);
    setPosition([{ order: 0, rowSpan: 1, colSpan: 4, col: 1, title: props.dataItem.title }]);
  }

  const displaySubView = (props) => {
    const title = props?.dataItem?.title;
    if (!showedSubGrid?.map(item => item.title)?.includes(title)) {
      const tileitem = tiles.filter(item => item.title == title);
      if (tileitem.length > 0) {
        setShowedSubGrid([...showedSubGrid, tileitem[0]]);
      }

      const existingSubview = selectedTiles?.find(tile => tile.title === title);
      if (!existingSubview) {
        let obj = { order: position?.length, rowSpan: 1, colSpan: 4, col: 1, title: title }
        position?.push(obj);
        setPosition([...position]);
      }
    }
  }

  const openInputNamePopup = () => {
    setOpenNamePopup(true);
  }

  const saveCustomView = () => {
    setCustomViewKey(tempCustomViewKey);
    let currentTiles = _.cloneDeep(selectedTiles);
    let viewData = [];
    const updatedViewName = isEditMode ? customViewKey : tempCustomViewKey;

    if (_.isNil(updatedViewName) || updatedViewName?.trim() == "") {
      setErrorSnackbarMessage("Please provide a valid view name.");
      setErrorSnackbarOpen(true);
      return
    }

    if (viewsAllData !== null && viewsAllData !== undefined && (viewsAllData?.toString() ?? '') !== '') {
      viewData = viewsAllData?.filter(item => {
        const parts = item?.title?.split('/');
        return parts[parts.length - 1] === updatedViewName;
      });
    }

    if (viewData?.length > 0 && !isEditMode) {
      setErrorSnackbarOpen(true);
      setErrorSnackbarMessage(i18_en.viewNameAlreadyExists);
      setCustomViewKey("");
      return null;
    }

    if (currentTiles.length > 0) {
      currentTiles.forEach(e => {
        e['item'] = [];
      });
    }

    let data = {
      viewKeyName: updatedViewName,
      column: 2,
      place: position,
      mainGrid: currentTiles[0].title,
      subGrids: currentTiles.map(item => item.title),
      Tiles: currentTiles
    };

    if (isEditMode) {
      updatedViews = [data];
    } else {
      updatedViews.push(data);
    }

    setCustomViewKey("");
    if (viewData.length === 0) {
      postSavedViewsData(updatedViews);
      setOpenNamePopup(false);
    } else {
      fetchUpdateSavedViews(viewData[0].id, updatedViews);
    }

  }

  const handleSuccessSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSuccessSnackbarOpen(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorSnackbarOpen(false);
  };

  const handleReposition = (props) => {
    setPosition(props.value)
  }

  const [isShow, setFlagShow] = useState(true);

  const handleClick = () => {
    setFlagShow(!isShow);
  }

  const onCancelNamePopup = () => {
    setOpenNamePopup(false)
    setCustomViewKey('');
  }

  const ViewNameContentData = (prop) => {
    if (prop?.sendDataToParent) {
      setTimeout(() => {
        prop.sendDataToParent('modalPopup');
      }, 100);
    }
    
    return (
      <Box
        sx={{
          bgcolor: "background.paper",
          p: 2
        }}
        id="modalPopup"
      >
        <TextField
          label="Custom View Name"
          defaultValue={customViewKey}
          onChange={e => { tempCustomViewKey = e.target.value }}
          fullWidth
          required
        />
      </Box>
    )
  }

  const RenderActionButtons = () => {
    return (
      <>
        <Button variant="contained" onClick={saveCustomView}>
          OK
        </Button>
        <Button variant="outlined" onClick={onCancelNamePopup}>
          Cancel
        </Button>
      </>
    )
  }

  const MainGridItemRender = (props) => {
    const { title } = { ...props.dataItem };
    return (
      <div style={{ display: 'flex', alignItems: "center", height: "30px" }} className='k-list-item'>
        <span style={{ width: '100%', paddingLeft: "8px" }} onClick={(e) => populateChildGrid(props, "mainGrid")}>{title}</span>
        {parentGrid?.trim() == title && <IconButton edge="end" sx={{ mr: .2 }} aria-label="delete" size="small" color='error' onClick={() => deleteMainGrid(props)}><CloseIcon /></IconButton>}
      </div>
    );
  };

  const deleteMainGrid = (props) => {
    setViews([]);
    setSelectedTiles([]);
    setSubGrid([]);
    setPosition();
    setParentGrid("");
  }

  const deleteSubGrid = (props) => {
    let colSpanCount = 0;
    let rowIndex = 0;
    const maxColSpan = 4;
    const title = props?.dataItem?.title;
    let tempPosition = [];

    const updatedPosData = position?.filter(item => item.title !== title);
    updatedPosData?.forEach((posItem, index) => {
      const isExists = tempPosition?.find(e => e.title == posItem.title);
      if (!isExists) {
        let executeTileReset = false;
        let futureValue = updatedPosData[index + 1];
        let tempVal = colSpanCount + posItem.colSpan;

        if (tempVal <= maxColSpan) { // Get Row wise tile data
          colSpanCount = tempVal;
          tempPosition.push({ ...posItem, order: rowIndex });
          if (!_.isNil(futureValue)) {
            tempVal = colSpanCount + futureValue?.colSpan;
            if (tempVal >= maxColSpan) {
              if (tempVal == maxColSpan) {
                tempPosition.push({ ...futureValue, order: rowIndex });
              }
              executeTileReset = true;
            }
          } else {
            executeTileReset = true;
          }
        }

        if (executeTileReset) {
          colSpanCount = 0;
          let listTiles = tempPosition.filter(x => x.order == rowIndex);
          const totalVal = _.sumBy(listTiles, 'colSpan');
          listTiles.forEach((tile, i) => {
            let tempVal = _.sumBy(listTiles.slice(0, i), 'colSpan');
            let data = tempPosition.find(e => e.title == tile?.title);
            if (i === listTiles.length - 1) {
              data.colSpan = maxColSpan - (totalVal - tile?.colSpan);
              data.col = tempVal + 1;
            } else {
              data.colSpan = tile?.colSpan;
              data.col = i == 0 ? 1 : tile?.col;
            }
          })
          rowIndex++;
        }
      }
    });

    setPosition(tempPosition);
    setShowedSubGrid(showedSubGrid.filter(item => item.title !== title));
    setSelectedTiles(selectedTiles.filter(item => item.title !== title));
  }

  const SubGridItemRender = (props) => {
    const { title } = { ...props.dataItem };
    const visibleDeleteIcon = showedSubGrid.map(item => item.title).includes(title);
    return (
      <div style={{ display: 'flex', alignItems: "center", height: "30px" }} className='k-list-item'>
        <span style={{ width: '90%', paddingLeft: "8px" }} onClick={() => displaySubView(props)}>{title}</span>
        {visibleDeleteIcon && <IconButton edge="end" sx={{ mr: .2 }} aria-label="delete" size="small" color='error' onClick={() => deleteSubGrid(props)}><CloseIcon /></IconButton>}
      </div>
    );
  };

  return (
    <>
      {isLoading ? (<Spinner />) : (<></>)}

      <AlertComponent isSuccessSnackbarOpen={isSuccessSnackbarOpen} successSnackbarMessage={successSnackbarMessage} handleSuccessSnackbarClose={handleSuccessSnackbarClose}
        isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessage} handleErrorSnackbarClose={handleErrorSnackbarClose}
      />

      <Box component="main" sx={{ flexGrow: 1, p: 1, maxHeight: 'calc(100vh - 53px)', overflow: 'auto' }}>
        <Grid container spacing={0} >
          {isShow &&
            <Grid item width={240} style={{ display: 'flex', flexDirection: 'column' }} sx={{ backgroundColor: 'info.light', minHeight: 'calc(100vh - 75px)', }}>
              <Box sx={{ width: 240, height: 'auto', mb: 3, p: 1 }}>
                <Typography variant="body2" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>Master Flows</Typography>
                <ListBox style={{ height: 300, width: '100%' }}
                  className="listName"
                  data={dataMainGrids}
                  textField="title"
                  selectedField='selected'
                  item={MainGridItemRender}
                  onItemClick={(e) => populateChildGrid(e, "mainGrid")}
                />
              </Box>
              <Box sx={{ width: 240, height: 'auto', p: 1 }}>
                <Typography variant="body2" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>Child Flow</Typography>
                <ListBox style={{ height: 280, width: '100%' }}
                  className="listName"
                  data={subGrid}
                  textField="title"
                  selectedField='selected'
                  item={SubGridItemRender}
                  onItemClick={displaySubView}
                />
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                {isEditMode ? <Button autoFocus variant="contained"
                  onClick={saveCustomView}>
                  Update
                </Button>
                  : <Button autoFocus variant="contained" disabled={parentGrid.length == 0 ? true : false}
                    onClick={openInputNamePopup}>
                    Save
                  </Button>
                }
              </Box>
            </Grid>
          }
          <Grid item={true} elevation={0} sx={{ flexGrow: 0, pl: '0', alignItems: 'center' }}>
            <Box className="arrow-btn" onClick={handleClick}>
              {isShow ? <ArrowBackIosRoundedIcon color='secondary.contrastText' /> : <ArrowForwardIosRoundedIcon color='secondary.contrastText' />}
            </Box>
          </Grid>

          <Grid item xs className='grid-movement grid-height tile-layout-grid inherit-height'  >
            <TileLayout
              columns={4}
              rowHeight={300}
              gap={{
                rows: 10,
                columns: 10,
              }}
              positions={position ? position : []}
              items={selectedTiles}
              onReposition={handleReposition}
            />


          </Grid>

        </Grid>

        {/* open modal for Custom View Name */}
        {openNamePopup && <WindowComponent title={"Custom View Name"} visible={openNamePopup} initialWidth={430} initialHeight={230} minWidth={430} minHeight={230} onClose={onCancelNamePopup} dataComponent={ViewNameContentData} actionButtons={<RenderActionButtons />}/>}
      </Box>
    </>
  );
}

export default CreateCustomView;